<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'shared.modals.payment-detail.title' | translate }}
    </h5>
  </div>
  <div class="modal-body" *ngIf="currentPayment">
    <table class="detail-table">
      <tr *ngIf="currentPayment.amount">
        <td class="key">{{ 'shared.modals.payment-detail.table.amount' | translate }}</td>
        <td>{{ currentPayment.amount / 100 | currency:currentPayment.currency }}</td>
      </tr>
      <tr *ngIf="currentPayment.paymentProvider">
        <td class="key">{{ 'shared.modals.payment-detail.table.paymentProvider' | translate }}</td>
        <td>{{ 'shared.payment-provider.' + currentPayment.paymentProvider | translate }}</td>
      </tr>
      <tr *ngIf="currentPayment.reference">
        <td class="key">{{ 'shared.modals.payment-detail.table.reference' | translate }}</td>
        <td>{{ currentPayment.reference }}</td>
      </tr>
      <tr *ngIf="currentPayment.status">
        <td class="key">{{ 'shared.modals.payment-detail.table.status' | translate }}</td>
        <td>{{ currentPayment.status }}</td>
      </tr>
      <tr *ngIf="currentPayment.created">
        <td class="key">{{ 'shared.modals.payment-detail.table.created' | translate }}</td>
        <td>{{ currentPayment.created | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr *ngIf="currentPayment.updated">
        <td class="key">{{ 'shared.modals.payment-detail.table.updated' | translate }}</td>
        <td>{{ currentPayment.updated | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr>
        <td colspan="2">
          <hr>
        </td>
      </tr>
      <tr *ngIf="currentPayment.checkoutId">
        <td class="key">{{ 'shared.modals.payment-detail.table.checkoutId' | translate }}</td>
        <td>{{ currentPayment.checkoutId }}</td>
      </tr>
      <tr *ngIf="currentPayment.transactionId">
        <td class="key">{{ 'shared.modals.payment-detail.table.transactionId' | translate }}</td>
        <td>{{ currentPayment.transactionId }}</td>
      </tr>

      <tr *ngIf="currentPayment.approvalURL">
        <td class="key">{{ 'shared.modals.payment-detail.table.approvalURL' | translate }}</td>
        <td>{{ currentPayment.approvalURL }}</td>
      </tr>
      <tr *ngIf="currentPayment.checkoutURL">
        <td class="key">{{ 'shared.modals.payment-detail.table.checkoutURL' | translate }}</td>
        <td>{{ currentPayment.checkoutURL }}</td>
      </tr>
      <tr *ngIf="currentPayment.callbackSuccessURL">
        <td class="key">{{ 'shared.modals.payment-detail.table.callbackSuccessURL' | translate }}</td>
        <td>{{ currentPayment.callbackSuccessURL }}</td>
      </tr>
      <tr *ngIf="currentPayment.callbackCancelURL">
        <td class="key">{{ 'shared.modals.payment-detail.table.callbackCancelURL' | translate }}</td>
        <td>{{ currentPayment.callbackCancelURL }}</td>
      </tr>
      <tr *ngIf="currentPayment.callbackErrorURL">
        <td class="key">{{ 'shared.modals.payment-detail.table.callbackErrorURL' | translate }}</td>
        <td>{{ currentPayment.callbackErrorURL }}</td>
      </tr>
      <tr *ngIf="currentPayment.errorMessage">
        <td class="key">{{ 'shared.modals.payment-detail.table.errorMessage' | translate }}</td>
        <td>{{ currentPayment.errorMessage }}</td>
      </tr>
      <tr *ngIf="currentPayment.checkoutId ||
        currentPayment.transactionId ||
        currentPayment.approvalURL ||
        currentPayment.checkoutURL || 
        currentPayment.callbackSuccessURL ||
        currentPayment.callbackCancelURL ||
        currentPayment.callbackErrorURL ||
        currentPayment.errorMessage"
      >
        <td colspan="2">
          <hr>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="right message">
          <button class="btn btn-primary" (click)="toggleMessages()" [disabled]="!messages || messages.length === 0">
            <span *ngIf="!showMessages">{{ 'shared.modals.payment-detail.buttons.show-message' | translate }}</span>
            <span *ngIf="!!showMessages">{{ 'shared.modals.payment-detail.buttons.hide-message' | translate }}</span>
          </button>
        </td>
      </tr>
      <ng-container *ngIf="showMessages">
        <tr *ngFor="let m of messages">
          <td class="key message">{{ m.date | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
          <td class="message">
            {{ m.message | json }}
          </td>
        </tr>
      </ng-container>
    </table>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" ngbAutofocus type="button" (click)="onCloseModal()">
      {{ 'shared.modals.payment-detail.buttons.close' | translate }}
    </button>
  </div>
</div>
